import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useMeetingManager } from 'amazon-chime-sdk-component-library-react'
import { useMeetingStore } from '@stores/meeting'
import { ROUTES } from '@constants/routes'
import { useLeaveMeetingMutation } from '@/models'

export function useLeave(to: 'video' | 'phone') {
  const navigate = useNavigate()
  const [isLeaving, setIsLeaving] = useState(false)
  const { session, appointmentId, clearMeetingSession } = useMeetingStore((state) => ({
    session: state.session,
    appointmentId: state.appointmentId,
    clearMeetingSession: state.clearMeetingSession
  }))
  const meetingManager = useMeetingManager()
  const [leaveMeetingMutation] = useLeaveMeetingMutation()

  const leave = useCallback(async () => {
    if (isLeaving) return

    setIsLeaving(true)
    const destination = to === 'video' ? ROUTES.videoMeetingLeft : ROUTES.phoneMeetingLeft

    try {
      session?.audioVideo.stop()
      meetingManager.audioVideo?.stop()

      await meetingManager.leave()

      // Call leaveMeeting mutation without awaiting (fire-and-forget)
      if (appointmentId) {
        leaveMeetingMutation({ variables: { appointmentId } }).catch((error) => {
          console.error('Error calling leaveMeeting mutation:', error)
        })
      }

      clearMeetingSession()

      navigate(destination)
    } catch (error) {
      console.error('Error leaving meeting:', error)
      clearMeetingSession()
      navigate(destination)
    } finally {
      setIsLeaving(false)
    }
  }, [isLeaving, session, appointmentId, meetingManager, clearMeetingSession, navigate, leaveMeetingMutation])

  return { leave, isLeaving }
}
